import { router } from "@inertiajs/react"
import { Building2, Coffee } from "lucide-react"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

interface OnboardingModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function OnboardingModal({ open, onOpenChange }: OnboardingModalProps) {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const handleDismiss = () => {
    setLoading(true)
    router.post(
      "/organizations/dismiss_onboarding",
      {},
      {
        onSuccess: () => {
          setLoading(false)
          onOpenChange(false)
        },
        onError: () => {
          setLoading(false)
        },
      },
    )
  }

  const handleCreateOrg = () => {
    onOpenChange(false)
    router.visit("/organizations/new")
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl">{t("onboarding.title")}</DialogTitle>
          <DialogDescription>{t("onboarding.subtitle")}</DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-2 gap-4 py-4">
          <button
            onClick={handleCreateOrg}
            className="border-border hover:border-primary hover:bg-primary/5 flex cursor-pointer flex-col items-center gap-3 rounded-xl border-2 p-6 text-center transition-colors"
          >
            <div className="bg-primary/10 flex h-14 w-14 items-center justify-center rounded-full">
              <Building2 className="text-primary h-7 w-7" />
            </div>
            <div>
              <p className="text-sm font-semibold">
                {t("onboarding.create_org")}
              </p>
              <p className="text-muted-foreground mt-1 text-xs">
                {t("onboarding.create_org_desc")}
              </p>
            </div>
          </button>

          <button
            onClick={handleDismiss}
            disabled={loading}
            className="border-border hover:border-primary hover:bg-primary/5 flex cursor-pointer flex-col items-center gap-3 rounded-xl border-2 p-6 text-center transition-colors disabled:opacity-50"
          >
            <div className="bg-primary/10 flex h-14 w-14 items-center justify-center rounded-full">
              <Coffee className="text-primary h-7 w-7" />
            </div>
            <div>
              <p className="text-sm font-semibold">
                {t("onboarding.independent")}
              </p>
              <p className="text-muted-foreground mt-1 text-xs">
                {t("onboarding.independent_desc")}
              </p>
            </div>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
